
import Vue from 'vue';

export default Vue.extend({
  name: 'partsView',
  beforeMount() {
    this.$metronic.breadcrumbs.setBreadcrumbs([{ title: 'Parts', route: '/parts' }]);
  },
});
